<template>
  <v-app>    
    <v-main>
      <router-view></router-view>
    </v-main>
    <v-footer color="#1b1b1b" dark padless class="kodanto-footer">
      <v-container class="py-3 d-flex flex-wrap align-center justify-center kodanto-footer__row">
        <a class="kodanto-footer__brand" href="https://kodanto.gr/" target="_blank" rel="noopener" title="Kodanto — Κατασκευή ιστοσελίδων">
          <span>Ιστοσελίδα από</span>
          <img src="/kodanto-lockup-white.png" alt="Kodanto" width="97" height="22" loading="lazy" />
        </a>
        <span class="kodanto-footer__cta">Θέλετε τη δική σας ιστοσελίδα; <a href="https://kodanto.gr/" target="_blank" rel="noopener">Επικοινωνήστε μαζί μας →</a></span>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: "App",
  beforeCreate() {
    window.addEventListener("beforeunload", localStorage.clear());
  },
  components: {    
  },

  data: () => ({
  }),
};
</script>

<style>
.kodanto-footer { font-size: .85rem; }
.kodanto-footer__row { gap: 8px 28px; }
.kodanto-footer__brand { display: inline-flex; align-items: center; gap: 8px; color: #fff !important; text-decoration: none; opacity: .85; transition: opacity .15s; }
.kodanto-footer__brand:hover { opacity: 1; }
.kodanto-footer__brand img { display: block; height: 22px; width: auto; }
.kodanto-footer__cta { opacity: .85; }
.kodanto-footer__cta a { color: #ffb74d !important; font-weight: 600; text-decoration: none; }
.kodanto-footer__cta a:hover { text-decoration: underline; }
</style>
